export { ConsentModal } from "./consent-modal";
